import { render } from "./PlantPage.vue?vue&type=template&id=8cbc48e0&scoped=true"
import script from "./PlantPage.vue?vue&type=script&lang=js"
export * from "./PlantPage.vue?vue&type=script&lang=js"

import "./PlantPage.vue?vue&type=style&index=0&id=8cbc48e0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cbc48e0"]])

export default __exports__